import Vue from 'vue'
import { ref } from 'vue'
import { cloneDeep } from 'lodash'

import { getUserView, postUserView } from '../api.js'
import notifications from '../notifications.js'
import events from '../events.js'

var _vars = {
  viewPromise: undefined,
  apiLock: false,
  apiLockReleaseCallback: undefined,
}

function _createPromiseForApiReleaseCallback() {
  return new Promise((resolve) => {
    _vars.apiLockReleaseCallback = function (promiseContent) {
      resolve(promiseContent)
    }
  })
}

function _createPromiseForApiCall() {
  return getUserView()
    .then(response => {
      if (response.status !== 200) {
        throw new Error('unable to load user view')
      }
      return new View(response.data)
    })
    .catch(error => {
      console.error(error)
      notifications.pushError('Unable to load user data view.', error)
      _vars.viewPromise = undefined
    })
}

async function _updateView(viewRef, userId) {
  let success = false
  try {
    let response = await postUserView({ view: viewRef, userId: userId })
    if (response.status === 200) {
      // return ref(newView) // = newView
      success = true
    }
    else if (response.status === 403) {
      notifications.pushError('User does not have access to update data view.')
    }
    else {
      notifications.pushError(`Error updating data view: ${response.data}`)
    }
  }
  catch (error) {
    notifications.pushError(`Network Error: ${error}`, error)
  }
  return success
}

function _updatePromise(viewObj) {
  _vars.viewPromise = Promise.resolve(viewObj)
}


class View {
  constructor(viewObj) {
    this.viewRef = ref(viewObj)
  }

  async update(newView, userId) {
    let success = await _updateView(newView.viewRef, userId)
    if (success) {
      this.viewRef = ref(newView.viewRef) // = newView
      _updatePromise(this)
      events.trigger('viewUpdated')
    }
    JSON.stringify(this.viewRef)
    return success
  }

  getRef() {
    return this.viewRef
  }

  getDistrict() {
    if (this.viewRef.district === undefined) {
      return []
    }
    return this.viewRef.district
  }

  getSchoolYear() {
    if (this.viewRef.schoolYear === undefined) {
      return []
    }
    return this.viewRef.schoolYear
  }

  getPartition() {
    if (this.viewRef.partition === undefined) {
      return []
    }
    return this.viewRef.partition
  }

  getVendor() {
    if (this.viewRef.vendor === undefined) {
      return []
    }
    return this.viewRef.vendor
  }

  hasMultiple(key) {
    return this.viewRef[key] &&
      Array.isArray(this.viewRef[key]) &&
      this.viewRef[key].length > 1
  }

  removeValue(category, value) {
    let index = this.viewRef[category].indexOf(value)
    this.viewRef[category].splice(index, 1)
  }

  addValue(category, value) {
    if (this.viewRef[category] === undefined) {
      Vue.set(this.viewRef, category, [])
    }
    let index = this.viewRef[category].indexOf(value)
    if (index < 0) {
      this.viewRef[category].push(value)
    }
  }

  createCopy() {
    return new View(cloneDeep(this.viewRef))
    // return new View(this.viewObj)
  }
}

// const currentFilter = ref({
//   schoolYear: '23-24',
//   district: ['MN-030001', 'MN-0000NW'],
//   vendor: ['CST'],
// })

function get() {
  if (_vars.apiLock) {
    if (!_vars.viewPromise) {
      _vars.viewPromise = _createPromiseForApiReleaseCallback()
    }
  }
  else {
    if (!_vars.viewPromise) {
      // _vars.viewPromise = Promise.resolve(
      //   new View({
      //     schoolYear: ['23-24'],
      //     district: ['MN-030001', 'MN-0000NW'],
      //     vendor: ['CST'],
      //     partition: ['FL', 'MN', 'MO', 'AZ']
      //   })
      // )
      _vars.viewPromise = _createPromiseForApiCall()
    }
  }
  return _vars.viewPromise
}

function populate(viewData) {
  let updatedContent = new View(viewData)

  if (_vars.apiLock) {
    _vars.apiLockReleaseCallback(updatedContent)
    _vars.apiLock = false
  }
  else {
    _vars.viewPromise = Promise.resolve(updatedContent)
  }

  events.trigger('viewUpdated')

  return updatedContent
}

function apiLock(boolValue) {
  _vars.apiLock = boolValue

  if (_vars.apiLock && _vars.viewPromise === undefined) {
    _vars.viewPromise = _createPromiseForApiReleaseCallback()
  }
}

// addEventListener("keypress", (event) => {
//   console.log(event)
//   currentFilter.value.schoolYear = 'sum-24'
//   currentFilter.value.district = ['DEV-00001']

//   _vars.viewPromise.then(_view => {
//     _view.viewRef.schoolYear = ['sum-24']
//     _view.viewRef.partition = ['FL', 'MN', 'MO']
//   })
// });


export default {
  get,
  populate,
  apiLock,
}
